/**
 * Owner: Masa Bayu
 * File: document.ts
 * Date:Time: 2026-09-05 06:46
 * Description: QXW document root model and factory.
 */
import { createQXId } from './id';
import { createQXDocumentIdentity } from './identity';
export function createQXWDocument(input = {}) {
    const now = new Date().toISOString();
    const title = input.title ?? '';
    const applicationVersion = input.applicationVersion ?? '0.1.0';
    return {
        identity: createQXDocumentIdentity(input.id ?? createQXId('doc'), applicationVersion),
        metadata: {
            title,
            author: '',
            description: '',
            language: 'en',
            createdAt: now,
            updatedAt: now,
        },
        settings: {
            units: 'px',
        },
        theme: {
            id: createQXId('theme'),
            name: 'default',
        },
        assets: [],
        fonts: [],
        pages: [],
        elements: [],
        components: [],
        animations: [],
        interactions: [],
        publication: {
            id: createQXId('pub'),
        },
    };
}
//# sourceMappingURL=document.js.map